import { useState } from "react";
import { FeaturesForIpa } from "../examine/FeaturesForIpa";
import { IpaType } from "../../phonemes/ipa";
import { segmentPhonemes } from "../../phonemes/segmentPhonemes";

/** UI for entering in IPA and seeing the associated features */
export function SeeFeatures() {
  const [ipa, setIpa] = useState('');
  const [segments, setSegments] = useState(getSegments(''));

  function changeIpa(ipa: IpaType) {
    setIpa(ipa);
    setSegments(getSegments(ipa));
  }

  return (<>
    <textarea cols={80} rows={1} spellCheck={false} value={ipa}
      onChange={(event) => changeIpa(event.target.value)} />
    <br />
    <FeaturesForIpa segments={segments} key="features" />
  </>);
}

function getSegments(ipa: IpaType) {
  const normalized = ipa.replaceAll(/\s/g, ' ');
  return segmentPhonemes(normalized, 'ipa', 'all-aff');
}
